import {
    CountryStateState,
    Country,
} from '../../../src/Definitions/CountryState';
import { DEFAULT_STATE } from './constants';

export const reducer = (
    state = DEFAULT_STATE,
    action: any
): CountryStateState => {
    switch ( action.type ) {
        case 'SET_COUNTRIES':
            return {
                ...state,
                countries: action.countries.reduce(
                    ( acc: Record< string, Country >, country: Country ) => {
                        acc[ country.code ] = country;
                        return acc;
                    },
                    {}
                ),
            };

        case 'SET_STATES':
            return {
                ...state,
                countries: {
                    ...state.countries,
                    [ action.countryCode ]: {
                        ...state.countries[ action.countryCode ],
                        states: action.states,
                    },
                },
            };

        case 'START_RESOLUTION':
            return {
                ...state,
                isLoading: {
                    ...state.isLoading,
                    [ action.selector ]: true,
                },
            };

        case 'FINISH_RESOLUTION':
            return {
                ...state,
                isLoading: {
                    ...state.isLoading,
                    [ action.selector ]: false,
                },
            };

        case 'SET_ERROR':
            return {
                ...state,
                errors: {
                    ...state.errors,
                    [ action.selector ]: action.error,
                },
            };

        default:
            return state;
    }
};
